// extracted by mini-css-extract-plugin
export default {"history":"styles_history__MgdpH","historyItem":"styles_historyItem__xVW7W","historyAvatar":"styles_historyAvatar__KXjNe"};